export default "__VITE_ASSET__BcL_Y22q__"